module.exports = __webpack_public_path__ + "static/img/mini-car.933991f7.svg";